import { navigate } from "gatsby"
import React, { useEffect, useRef } from "react"
import styled from "styled-components"
import Container from "styleguide/components/grid/Container"
import { H1 } from "styleguide/components/Text"
import IconSearch from "styleguide/icons/IconSearch"
import { uiColorToBaseColor } from "styleguide/styles/colors"
import media from "styleguide/styles/media-queries"

interface Props {
  category: string
  searchQuery: string
  onSearchQueryChange: (q: string) => void
}

const StyledHeading = styled(H1)`
  color: ${uiColorToBaseColor("darkestGray")};
  margin-bottom: 24px;
  text-transform: capitalize;
  ${media.tablet`
    font-weight: 800;
    margin-top: 188px;
  `}
`

const StyledContainer = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    display: none !important;
  }

  ${media.desktop`
     flex-direction:column;
    align-items:flex-start;
  `}
`

const StyledInput = styled.input`
  font-size: 16px;
  line-height: 24px;
  color: ${uiColorToBaseColor("gray")};
  border: none;

  &:focus {
    outline: none;
  }

  ::placeholder {
    font-size: 16px;
    line-height: 24px;
    color: ${uiColorToBaseColor("gray")};
  }
`

const InputBoxContainer = styled.div`
  display: flex;
  border: 1px solid ${uiColorToBaseColor("lightGray")};
  border-radius: 20px;
  height: 24px;
  width: 220px;
  padding: 8px 16px 8px 24px;
  align-items: center;
  justify-content: space-between;

  ${media.desktop`
    margin-bottom: 32px;
    height:auto;
    width: -webkit-fill-available;
  `}
`

const StyledIconSearch = styled(IconSearch)`
  width: 16px;
  height: 16px;
  text-align: center;
`

const BlogHero = ({ category, onSearchQueryChange, searchQuery }: Props) => {
  const handleEnterKeyPress = e => {
    if (e.key === "Enter") {
      navigate(`/blog/all-topics/?q=${searchQuery}`)
    }
  }

  const searchInput = useRef()

  useEffect(() => {
    if (searchQuery && searchInput.current) {
      searchInput.current.focus()
    }
  }, [])

  return (
    <StyledContainer>
      <StyledHeading>
        ShakaCode blog
        {category === "favorites" ? "" : ` - ${category}`}
      </StyledHeading>
      <InputBoxContainer>
        <StyledInput
          type="text"
          aria-label="Search"
          value={searchQuery}
          placeholder="Search"
          onChange={e => onSearchQueryChange(`${e.target.value}`)}
          onKeyDown={handleEnterKeyPress}
          ref={searchInput}
        />
        <StyledIconSearch />
      </InputBoxContainer>
    </StyledContainer>
  )
}
export default BlogHero
